export default "__VITE_ASSET__6Mitku$p__"